import { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import moment from "moment";
import DataTable from "react-data-table-component";
import Select from "react-select";
import { DateRangePicker } from "react-date-range";

/* COMPONENTS */
import Input from "../../../components/input";

/* MATERIAL TAILWIND COMPONENTS */
import {
  Button,
  Dialog,
  DialogBody,
  Menu,
  MenuHandler,
  MenuItem,
  MenuList,
} from "@material-tailwind/react";

/* ICONS */
import { IoClose } from "react-icons/io5";
import { GoKebabHorizontal } from "react-icons/go";

/* TOAST NOTIFICATION */
import { toast } from "react-toast";

/* API IMPORT */
import {
  deleteRegistrationDetailsById,
  exportRegistrationList,
  getRegistrationById,
  getRegistrationList,
  patchChangeStatusRegistrationDetailsById,
  patchBulkChangeStatusRegistrationDetailsById,
  putEditRegistrationDetailsById,
  regeneratePaymentLink,
} from "../../../service/api/registrationForm.api";

/* CONFIG URL */
import { IMAGE_URL } from "config";

import {
  normalizeParticipationEvents,
  normalizeParticipationEventsMap,
  participationEvents,
} from "../../../data/participationEvents";
import { standingCommittees } from "../../../data/standingCommittees";
import {
  getMeetingLocationApiValue,
  meetingLocations,
} from "../../../data/meetingLocations";

import ExcelExport from "../../../components/export/Export";
import { getZonesAPI } from "service/api/zone.api";

const filterByType = [
  { value: null, label: "Clear filters" },
  {
    value: "KAROBARI",
    label: "Karobari Samiti and Madhyastha Mahasamiti Meeting",
  },
  {
    value: "MADHYASTHA",
    label: "Madhyastha Mahasamiti Meeting",
  },
];

const stateOptions = [
  {
    label: "Not Applicable (Overseas/NRI Delegate)",
    value: "Not Applicable (Overseas/NRI Delegate)",
  },
  {
    label: "Andhra Pradesh / આંધ્ર પ્રદેશ",
    value: "Andhra Pradesh / આંધ્ર પ્રદેશ",
  },
  {
    label: "Arunachal Pradesh / અરુણાચલ પ્રદેશ",
    value: "Arunachal Pradesh / અરુણાચલ પ્રદેશ",
  },
  { label: "Assam / અસ્સામ", value: "Assam / અસ્સામ" },
  { label: "Bihar / બિહાર", value: "Bihar / બિહાર" },
  { label: "Chhattisgarh / છત્તીસગઢ", value: "Chhattisgarh / છત્તીસગઢ" },
  { label: "Goa / ગોવા", value: "Goa / ગોવા" },
  { label: "Gujarat / ગુજરાત", value: "Gujarat / ગુજરાત" },
  { label: "Haryana / હરયાણા", value: "Haryana / હરયાણા" },
  {
    label: "Himachal Pradesh / હિમાચલ પ્રદેશ",
    value: "Himachal Pradesh / હિમાચલ પ્રદેશ",
  },
  { label: "Jharkhand / ઝારખંડ", value: "Jharkhand / ઝારખંડ" },
  { label: "Karnataka / કર્ણાટક", value: "Karnataka / કર્ણાટક" },
  { label: "Kerala / કેરળ", value: "Kerala / કેરળ" },
  {
    label: "Madhya Pradesh / મધ્ય પ્રદેશ",
    value: "Madhya Pradesh / મધ્ય પ્રદેશ",
  },
  { label: "Maharashtra / મહારાષ્ટ્ર", value: "Maharashtra / મહારાષ્ટ્ર" },
  { label: "Manipur / મણિપુર", value: "Manipur / મણિપુર" },
  { label: "Meghalaya / મેઘાલય", value: "Meghalaya / મેઘાલય" },
  { label: "Mizoram / મિઝોરમ", value: "Mizoram / મિઝોરમ" },
  { label: "Nagaland / નાગાલેંડ", value: "Nagaland / નાગાલેંડ" },
  { label: "Odisha / ઓડિશા", value: "Odisha / ઓડિશા" },
  { label: "Punjab / પંજાબ", value: "Punjab / પંજાબ" },
  { label: "Rajasthan / રાજસ્થાન", value: "Rajasthan / રાજસ્થાન" },
  { label: "Sikkim / સિક્કિમ", value: "Sikkim / સિક્કિમ" },
  { label: "Tamil Nadu / તમિલ નાડુ", value: "Tamil Nadu / તમિલ નાડુ" },
  { label: "Telangana / તેલંગાણા", value: "Telangana / તેલંગાણા" },
  { label: "Tripura / ત્રિપુરા", value: "Tripura / ત્રિપુરા" },
  {
    label: "Uttar Pradesh / ઉત્તર પ્રદેશ",
    value: "Uttar Pradesh / ઉત્તર પ્રદેશ",
  },
  { label: "Uttarakhand / ઉત્તરાખંડ", value: "Uttarakhand / ઉત્તરાખંડ" },
  { label: "West Bengal / પશ્ચિમ બંગાલ", value: "West Bengal / પશ્ચિમ બંગાલ" },
  {
    label: "Andaman and Nicobar Islands / અંદામાન અને નિકોબાર દ્વીપ",
    value: "Andaman and Nicobar Islands / અંદામાન અને નિકોબાર દ્વીપ",
  },
  { label: "Chandigarh / ચંડીગઢ", value: "Chandigarh / ચંડીગઢ" },
  {
    label:
      "Dadra & Nagar Haveli and Daman & Diu / દાદરા અને નગર હવેલી તથા દમણ અને દીવ",
    value:
      "Dadra & Nagar Haveli and Daman & Diu / દાદરા અને નગર હવેલી તથા દમણ અને દીવ",
  },
  { label: "Delhi / દિલ્લી", value: "Delhi / દિલ્લી" },
  {
    label: "Jammu and Kashmir / જમ્મુ અને કાશ્મીર",
    value: "Jammu and Kashmir / જમ્મુ અને કાશ્મીર",
  },
  { label: "Lakshadweep / લક્ષદ્વીપ", value: "Lakshadweep / લક્ષદ્વીપ" },
  { label: "Puducherry / પુડુચેરી", value: "Puducherry / પુડુચેરી" },
  { label: "Ladakh / લદાખ", value: "Ladakh / લદાખ" },
];

const filterByStatus = [
  { value: null, label: "All" },
  // { value: 1, label: "Pending" },
  { value: 3, label: "Unpaid" },
  { value: 4, label: "Approved" },
  { value: 5, label: "Rejected" },
  { value: 6, label: "Paid & Email Sent" },
];

/* CLICK OUTSIDE HANDLER */
const useClickOutside = (handler) => {
  let domNode = useRef();

  useEffect(() => {
    let maybeHandler = (event) => {
      if (!domNode.current?.contains(event.target)) {
        handler();
      }
    };

    document.addEventListener("mousedown", maybeHandler);
    return () => {
      document.removeEventListener("mousedown", maybeHandler);
    };
  });

  return domNode;
};

const RegistrationUs = () => {
  // STATE VARIABLES
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(50);

  const [registrationFormList, setRegistrationUsList] = useState([]);
  const [totalDocs, setTotalDocs] = useState([]);
  const [search, setSearch] = useState("");
  const [deleteId, setDeleteId] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);

  const [selectedList, setSelectedList] = useState([]);


  const [nationalList, setNationalList] = useState([]);
  const [internationalList, setInternationalList] = useState([]);

  const [updateAllModal, setUpdateAllModal] = useState(false);
  const [updateAllStatus, setUpdateAllStatus] = useState(null);

  const [editModal, setEditModal] = useState(false);
  const [editDetails, setEditDetails] = useState(null);
  const [editDetailsLoading, setEditDetailsLoading] = useState(false);

  const [removeDetailsId, setRemoveDetailsId] = useState(null);
  const [removeDetailsModal, setRemoveDetailsModal] = useState(false);

  const [viewModal, setViewModal] = useState(false);
  const [selectedRegistration, setSelectedRegistration] = useState(null);
  const [viewDetailsLoading, setViewDetailsLoading] = useState(false);
  const [regenerateLinkLoading, setRegenerateLinkLoading] = useState(false);
  const [status, setStatus] = useState(null);
  const [datepicker, setDatepicker] = useState(false);

  const [state, setState] = useState([
    {
      startDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth() - 6,
        1,
      ),
      endDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
      key: "selection",
      color: "#ef4444",
    },
  ]);

  const [meetingType, setMeetingType] = useState(null);
  const [location, setLocation] = useState("Nashik");

  /* FUNCTIONS */
  const handlePageChange = async (e) => {
    setPage(e);
    getRegistrationListFunction();
  };

  /* HANDLE DELETE DATA */
  const handleDelete = () => {
    deleteRegistrationDetailsById(removeDetailsId)
      .then((res) => {
        toast.success(res?.message);
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message);
      })
      .finally(() => {
        setRemoveDetailsModal(!removeDetailsModal);
        setRemoveDetailsId(null);
        getRegistrationListFunction();
      });
  };

  const handlePerPageChange = async (e) => {
    setSizePerPage(e);
    getRegistrationListFunction();
  };

  const buildRegistrationParams = () => {
    const params = {
      page: page,
      sizePerPage: sizePerPage,
      pagination: false,
    };

    const meetingLocation = getMeetingLocationApiValue(location);
    if (meetingLocation) {
      params.meetingLocation = meetingLocation;
    }

    if (search) {
      params.search = search;
    }

    if (status !== null) {
      params.status = status?.value;
    }

    if (meetingType !== null) {
      params.type = meetingType?.value;
    }

    if (state?.[0]?.startDate && state?.[0]?.endDate) {
      params.startDate = state?.[0]?.startDate;
      params.endDate = state?.[0]?.endDate;
    }

    return params;
  };

  const getRegistrationListFunction = () => {
    setLoading(true);
    setSelectedList([]);
    const params = buildRegistrationParams();

    getRegistrationList(params)
      .then((res) => {
        setRegistrationUsList(res?.data);
        setTotalDocs(res?.data?.length);
      })
      .catch((e) => {
        console.log("e-->", e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleExportRegistrationList = async () => {
    try {
      const params = buildRegistrationParams();
      const res = await exportRegistrationList(params);
      const rows = res?.data || [];

      if (!rows.length) {
        toast.error("No data to export");
      }

      return rows;
    } catch (e) {
      toast.error(e?.response?.data?.message || "Failed to export");
      return [];
    }
  };

  /* HANDLE CHANGE STATUS */
  const handleStatusChange = (editId, type) => {
    patchChangeStatusRegistrationDetailsById(editId, { type })
      .then((res) => {
        toast.success(res?.message);
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message);
      })
      .finally(() => {
        setTimeout(() => {
          getRegistrationListFunction();
        }, 1500);
      });
  };

  const handleEditDetails = () => {
    setEditDetailsLoading(true);
    const obj = {
      name: editDetails?.name,
      email: editDetails?.email,
    };
    if (editDetails?.organization) {
      obj.organization = editDetails?.organization;
    }
    if (editDetails?.standingCommittee !== undefined) {
      obj.standingCommittee = editDetails.standingCommittee;
    }
    if (editDetails?.designation) {
      obj.designation = editDetails?.designation;
    }
    if (editDetails?.region) {
      obj.region = editDetails?.region;
    }
    if (editDetails?.state) {
      obj.state = editDetails?.state;
    }
    if (editDetails?.zone) {
      obj.zone = editDetails?.zone;
    }
    if (location === "Nashik") {
      obj.participationEvents = normalizeParticipationEventsMap(
        editDetails?.participationEvents,
      );
    }
    putEditRegistrationDetailsById(editDetails?._id, obj)
      .then((res) => {
        toast.success(res?.message);
        setEditModal(!editModal);
        setEditDetails(null);
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message);
      })
      .finally(() => {
        setEditDetailsLoading(false);
        setTimeout(() => {
          getRegistrationListFunction();
        }, 1500);
      });
  };

  const handleChangeSelected = (id) => {
    let tempArray = [];
    if (id.selectedRows?.length > 0) {
      id.selectedRows?.forEach((element) => {
        tempArray.push({
          id: element?._id,
          status: element?.status,
        });
      });
    }
    setSelectedList(tempArray);
  };

  const handleCombineStatusChange = () => {
    if (!updateAllStatus) {
      toast.error("Please select any status");
    } else if (selectedList?.length === 0) {
      toast.error("Please select any details");
    } else {
      const idList = [];
      selectedList?.forEach((el) => {
        if (!idList?.find((ele) => ele === el?.id)) {
          idList.push(el?.id);
        }
      });

      patchBulkChangeStatusRegistrationDetailsById({
        idList: idList,
        type: updateAllStatus?.value,
      })
        .then((res) => {
          toast.success(res?.message);
          setUpdateAllModal(false);
        })
        .catch((e) => {
          toast.error(e?.response?.data?.message);
        })
        .finally(() => {
          setTimeout(() => {
            getRegistrationListFunction();
          }, 1500);
        });
    }
  };

  /* GET ZONES FUNCTION */
  const getZones = () => {
    getZonesAPI({
      pagination: false,
    })
      .then((res) => {
        let nationalTemp = [];
        let internationalTemp = [];
        res?.data?.forEach((element) => {
          if (
            element?.address?.[0] &&
            element?.address[0]?.country === "India"
          ) {
            nationalTemp.push({
              label: element?.name,
              value: element?._id,
            });
          } else {
            internationalTemp.push({
              label: element?.name,
              value: element?._id,
            });
          }
          setNationalList(nationalTemp);
          setInternationalList(internationalTemp);
        });
      })
      .finally(() => {})
      .catch((err) => {
        console.log("Error: ", err);
      });
  };

  const getPaymentStatusLabel = (paymentStatus) => {
    if (paymentStatus === "success") {
      return { label: "Paid", className: "text-green-600" };
    }
    if (paymentStatus === "cancelled") {
      return { label: "Cancelled", className: "text-red-500" };
    }
    return { label: "Pending", className: "text-amber-600" };
  };

  const renderParticipationEventsSection = (events) => {
    const normalizedEvents = normalizeParticipationEvents(events);

    return (
      <div className="mb-4 border-t border-authBorder pt-4">
        <p className="text-md font-ibm-semibold text-black mb-3">
          Participation Events
        </p>
        {normalizedEvents.length > 0 ? (
          <ul className="list-disc pl-5 space-y-2">
            {normalizedEvents.map((event, index) => (
              <li
                key={event.id || index}
                className="text-md font-ibm-regular text-greyText"
              >
                {event.label || event.id}
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-md font-ibm-regular text-greyText">None</p>
        )}
      </div>
    );
  };

  const toggleParticipationEvent = (eventId) => {
    const current = normalizeParticipationEventsMap(
      editDetails?.participationEvents,
    );

    setEditDetails({
      ...editDetails,
      participationEvents: {
        ...current,
        [eventId]: !current[eventId],
      },
    });
  };

  const handleViewRegistrationDetails = (row) => {
    setViewModal(true);
    setViewDetailsLoading(true);
    setSelectedRegistration(row);

    getRegistrationById(row?._id)
      .then((res) => {
        if (res?.data) {
          setSelectedRegistration(res.data);
        }
      })
      .catch((e) => {
        toast.error(
          e?.response?.data?.message || "Failed to load payment details",
        );
      })
      .finally(() => {
        setViewDetailsLoading(false);
      });
  };

  const handleCopyPaymentLink = async (link) => {
    if (!link) {
      toast.error("No payment link available to copy");
      return;
    }

    try {
      await navigator.clipboard.writeText(link);
      toast.success("Link copied — paste in WhatsApp to share");
    } catch (error) {
      toast.error("Failed to copy payment link");
    }
  };

  const handleRegeneratePaymentLink = () => {
    if (!selectedRegistration?._id) {
      return;
    }

    setRegenerateLinkLoading(true);

    regeneratePaymentLink(selectedRegistration._id)
      .then((res) => {
        toast.success(res?.message || "New payment link generated");
        setSelectedRegistration((prev) => ({
          ...prev,
          paymentLink: res?.data?.paymentLink || res?.data?.paymentUrl,
          shareablePaymentUrl: res?.data?.shareablePaymentUrl,
          paymentId: res?.data?.paymentId,
          paymentStatus: res?.data?.paymentStatus || "pending",
        }));
        getRegistrationListFunction();
      })
      .catch((e) => {
        toast.error(
          e?.response?.data?.message || "Failed to generate payment link",
        );
      })
      .finally(() => {
        setRegenerateLinkLoading(false);
      });
  };

  const canRegeneratePaymentLink =
    selectedRegistration?.paymentStatus !== "success" &&
    selectedRegistration?.paymentMode === "PHONEPE";

  const caseInsensitiveSortForName = (rowA, rowB) => {
    const a = rowA.name.toLowerCase();
    const b = rowB.name.toLowerCase();

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };

  const caseInsensitiveSortForType = (rowA, rowB) => {
    const a = rowA.type.toLowerCase();
    const b = rowB.type.toLowerCase();

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };

  const caseInsensitiveSortForStatus = (rowA, rowB) => {
    const a = rowA.status;
    const b = rowB.status;

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };

  const caseInsensitiveSortForDateAndTime = (rowA, rowB) => {
    const a = rowA.createdAt.toLowerCase();
    const b = rowB.createdAt.toLowerCase();

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };

  /* DATATABLE COLUMNS */
  const columns = [
    {
      name: "Sr. No",
      grow: 0,
      selector: (row, index) => (
        <span className="text-sm font-ibm-regular text-greyText">
          {index + 1}
        </span>
      ),
    },

    {
      name: "Name",
      grow: 1.5,
      selector: (row) => (
        <div className="p-0">
          <p className="text-sm font-ibm-semibold text-black">{row.name}</p>
          <a
            href={`mailto:${row.email}`}
            className="text-sm font-ibm-regular text-greyText hover:text-logoRed transition-all duration-300 ease-in-out mt-1 whitespace-pre-wrap"
          >
            {row.email}
          </a>
        </div>
      ),
      sortable: true,
      sortFunction: caseInsensitiveSortForName,
    },
    {
      name: "Phone",
      selector: (row) => (
        <a
          href={`tel:${row.phoneNumber}`}
          className="block text-sm font-ibm-regular text-greyText hover:text-logoRed transition-all duration-300 ease-in-out"
        >
          {row.phoneNumber}
        </a>
      ),
    },
    {
      name: "City",
      selector: (row) => (
        <p className="block text-sm font-ibm-regular text-greyText hover:text-logoRed transition-all duration-300 ease-in-out">
          {row.city}
        </p>
      ),
    },
    {
      name: "Payment",
      grow: 1,
      selector: (row) => {
        const paymentStatus = getPaymentStatusLabel(row?.paymentStatus);
        return (
          <div className="p-0">
            <p className="text-sm font-ibm-semibold text-black">
              {row?.amount ? `₹${row.amount}` : "-"}
            </p>
            <p
              className={`text-sm font-ibm-semibold ${paymentStatus.className} mt-1`}
            >
              {paymentStatus.label}
            </p>
            {row?.paymentMode && (
              <p className="text-xs font-ibm-regular text-greyText mt-1">
                {row.paymentMode}
              </p>
            )}
          </div>
        );
      },
    },
    ...(location === "Nashik"
      ? [
          {
            name: "Participation Events",
            grow: 0.8,
            selector: (row) => {
              const events = normalizeParticipationEvents(
                row.participationEvents,
              );

              return (
                <p className="text-sm font-ibm-regular text-greyText">
                  {events.length > 0 ? `${events.length} selected` : "None"}
                </p>
              );
            },
          },
        ]
      : []),
    {
      name: "Date & Time",
      grow: 1,
      selector: (row) => (
        <div className="p-0">
          <span className="block text-sm font-ibm-regular text-black text-opacity-60">
            {new Date(row.createdAt).toLocaleDateString("en-gb", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </span>
          <span className="block text-sm font-ibm-regular text-black text-opacity-60 mt-1">
            {new Date(row.createdAt).toLocaleTimeString("en-gb", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })}
          </span>
        </div>
      ),
      sortable: true,
      sortFunction: caseInsensitiveSortForDateAndTime,
    },
    {
      name: "Actions",
      selector: (row) => (
        <div className="flex items-center">
          <Menu>
            <MenuHandler>
              <Button className="shadow-none hover:shadow-none bg-white hover:bg-black hover:bg-opacity-10 rounded-full border border-greyBorder p-2">
                <GoKebabHorizontal className="w-3 h-3 text-greyText rotate-90" />
              </Button>
            </MenuHandler>
            <MenuList className="min-w-[20vh] p-2">
              <MenuItem
                className="bg-white hover:bg-black hover:bg-opacity-10 rounded-md text-base font-ibm-regular text-black"
                onClick={() => handleViewRegistrationDetails(row)}
              >
                View details
              </MenuItem>
              <MenuItem
                className="bg-white hover:bg-black hover:bg-opacity-10 rounded-md text-base font-ibm-regular text-black"
                onClick={() => {
                  setEditDetails({
                    ...row,
                    participationEvents: normalizeParticipationEventsMap(
                      row.participationEvents,
                    ),
                  });
                  setEditModal(!editModal);
                }}
              >
                Edit details
              </MenuItem>
              <MenuItem
                className="bg-white hover:bg-black hover:bg-opacity-10 rounded-md text-base font-ibm-regular text-black"
                onClick={() => {
                  setRemoveDetailsId(row?._id);
                  setRemoveDetailsModal(true);
                }}
              >
                Remove details
              </MenuItem>
              {(row?.status === 2 || row?.status === 6) && (
                <>
                  <MenuItem
                    className="bg-white hover:bg-black hover:bg-opacity-10 rounded-md text-base font-ibm-regular text-black"
                    onClick={() => {
                      handleStatusChange(row?._id, "approved");
                    }}
                  >
                    Approve registration
                  </MenuItem>
                  <MenuItem
                    className="bg-white hover:bg-black hover:bg-opacity-10 rounded-md text-base font-ibm-regular text-black"
                    onClick={() => {
                      setDeleteModal(!deleteModal);
                      setDeleteId(row?._id);
                    }}
                  >
                    Reject registration
                  </MenuItem>
                </>
              )}
              {/* {( row?.status === 6) && (
               
              )} */}
            </MenuList>
          </Menu>
        </div>
      ),
    },
  ];

  /* LOADING SCREEN FOR DATATABLE */
  const LoadingScreen = () => {
    return (
      <div className="w-full bg-[#F5F5F5] bg-opacity-50 rounded-md border border-authBorder py-5">
        <p className="text-sm font-proxima-semibold text-black text-center">
          Please wait!
        </p>
        <p className="text-sm font-proxima-semibold text-black text-center">
          We are fetching data{" "}
        </p>
      </div>
    );
  };

  const NoDataScreen = () => {
    return (
      <div className="w-full bg-[#F5F5F5] bg-opacity-50 rounded-md border border-authBorder py-5">
        <p className="text-sm font-ibm-semibold text-black text-center">
          There are no queries to display.
        </p>
      </div>
    );
  };

  /* DOM NODE */
  let domNode = useClickOutside(() => {
    setDatepicker(false);
  });

  /* USE-EFFECTS */
  useEffect(() => {
    getRegistrationListFunction();
  }, [
    page,
    sizePerPage,
    search,
    status,
    meetingType,
    state,
    location,
  ]);

  useEffect(() => {
    if (!viewModal || !selectedRegistration?._id) {
      return;
    }

    if (selectedRegistration?.paymentStatus === "success") {
      return;
    }

    const registrationId = selectedRegistration._id;

    const pollRegistrationDetails = () => {
      getRegistrationById(registrationId)
        .then((res) => {
          if (!res?.data) {
            return;
          }

          setSelectedRegistration((prev) => {
            if (
              prev?.paymentStatus !== "success" &&
              res.data.paymentStatus === "success"
            ) {
              toast.success("Payment received successfully");
              getRegistrationListFunction();
            }
            return res.data;
          });
        })
        .catch(() => {});
    };

    const intervalId = setInterval(pollRegistrationDetails, 30000);

    return () => clearInterval(intervalId);
  }, [
    viewModal,
    selectedRegistration?._id,
    selectedRegistration?.paymentStatus,
  ]);

  useEffect(() => {
    getZones();
  }, []);

  return (
    <section className="px-0 py-2 xl:p-5 lg:p-5 min-h-screen xl:min-h-full lg:min-h-full">
      {/* PAGE TITLE */}
      <Helmet>
        <title>Registration Form Details | LMP Registration</title>
      </Helmet>

      <div className="container-full-width">
        {/* HEADING */}
        <div className="block xl:flex lg:flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-ibm-bold text-black tracking-tight">
              Registration Form Details
            </h1>
            <h2 className="text-base font-ibm-regular text-greyText">
              Handle the registrations submitted through the website.
            </h2>
          </div>
          <div className="block xl:flex lg:flex items-center gap-2 mt-3 xl:mt-0 lg:mt-0">
            {/* DATE RANGE FILTER */}
            <div className="relative">
              <div ref={domNode}>
                <input
                  type="text"
                  name="dateRange"
                  placeholder="Filter by date range"
                  value={
                    state?.[0]?.startDate && state?.[0]?.endDate
                      ? ` ${state?.[0]?.startDate &&
                          moment(state?.[0]?.startDate).format(
                            "DD/MM/YYYY",
                          )} - ${state?.[0]?.endDate &&
                          moment(state?.[0]?.endDate).format("DD/MM/YYYY")}`
                      : "Select Date"
                  }
                  onClick={() => setDatepicker(!datepicker)}
                  className={`w-full xl:w-[25vh] lg:w-[25vh] bg-white outline-none font-ibm-regular text-${
                    state?.[0]?.startDate && state?.[0]?.endDate
                      ? "text-black"
                      : " text-gray-400"
                  } text-sm focus:outline-none border border-greyBorder rounded-md px-5 py-3`}
                />
              </div>
              {datepicker && (
                <div
                  ref={domNode}
                  className="absolute top-12 bottom-0 transition-all duration-300 ease-linear z-50"
                >
                  <DateRangePicker
                    dragSelectionEnabled
                    showPreview
                    onChange={(item) => setState([item.selection])}
                    showSelectionPreview={true}
                    moveRangeOnFirstSelection={true}
                    months={1}
                    ranges={state}
                    direction="horizontal"
                    preventSnapRefocus={true}
                    calendarFocus="backwards"
                    className="shadow-xl font-ibm-regular rounded-xl border border-greyBorder cursor-pointer"
                  />
                </div>
              )}
            </div>

            {/* FILTER BY TYPE */}
            <div className="w-full xl:w-[15vh] lg:w-[15vh] flex-shrink-0 mt-2 xl:mt-0 lg:mt-0">
              <Select
                options={filterByStatus}
                className="react-select font-proxima-regular"
                classNamePrefix="filter"
                placeholder="Status"
                name="status"
                value={status}
                onChange={(e) => setStatus(e)}
              />
            </div>

            {/* FILTER BY TYPE */}
            {/* <div className="w-full xl:w-[25vh] lg:w-[25vh] flex-shrink-0 mt-2 xl:mt-0 lg:mt-0">
              <Select
                options={filterByType}
                className="react-select font-proxima-regular"
                classNamePrefix="filter"
                placeholder="Meeting Type"
                value={meetingType}
                onChange={(e) => setMeetingType(e)}
              />
            </div> */}

            {/* SEARCHBAR */}
            <div className="w-full xl:w-full lg:w-full mt-2 xl:mt-0 lg:mt-0">
              <Input
                type="text"
                placeholder="Search..."
                name="search"
                id="search"
                value={search}
                onChange={(e) => setSearch(e?.target?.value)}
              />
            </div>

            {/* UPDATE ALL BUTTON */}
            {selectedList?.length > 0 && (
              <Button
                onClick={() => setUpdateAllModal(!updateAllModal)}
                type="button"
                className="w-full text-base shadow-none hover:shadow-none  hover:bg-opacity-80 px-5 py-3 rounded-md font-ibm-semibold text-white transition-all duration-300 ease-in-out normal-case"
              >
                Update All
              </Button>
            )}

            <ExcelExport
              content={"Export"}
              fileName="bulkExport"
              onExport={handleExportRegistrationList}
            />
          </div>
        </div>

        {/* DATATABLE */}
        <div className="mt-5">
          <div className="w-full max-w-full overflow-x-auto">
            <div className="inline-flex min-w-full flex-wrap items-center gap-1 bg-white border border-greyBorder shadow-inner p-2 rounded-lg">
              {meetingLocations.map((item) => (
                <Button
                  key={item.value}
                  onClick={() => setLocation(item.value)}
                  className={`shadow-none hover:shadow-none font-ibm-semibold rounded-md ${
                    location === item.value
                      ? "bg-[#EF4444] hover:bg-opacity-80 text-white"
                      : "bg-white hover:bg-[#EF4444]/10 text-black"
                  } px-6 py-2.5 text-base normal-case transition-all duration-300 ease-in-out`}
                >
                  {item.label}
                </Button>
              ))}
            </div>
          </div>

          <div className="mt-3">
            <DataTable
              className="data-table"
              selectableRows
              onSelectedRowsChange={handleChangeSelected}
              columns={columns}
              data={registrationFormList}
              progressPending={loading}
              progressComponent={<LoadingScreen />}
              pagination
              paginationTotalRows={totalDocs}
              rowsPerPage={sizePerPage}
              onChangeRowsPerPage={handlePerPageChange}
              onChangePage={handlePageChange}
              noDataComponent={<NoDataScreen />}
              paginationRowsPerPageOptions={[50, 100]}
              paginationPerPage={sizePerPage}
              defaultSortFieldId={1}
            />
          </div>
        </div>

        {/* REJECT MODAL */}
        <Dialog
          open={deleteModal}
          handler={() => setDeleteModal(!deleteModal)}
          size="xs"
          animate={{
            mount: { scale: 1, y: 0 },
            unmount: { scale: 0.9, y: -100 },
          }}
        >
          <DialogBody className="p-0">
            <div className="border-b border-authBorder px-5 py-3 flex items-center justify-between">
              <h5 className="text-lg font-ibm-bold text-black tracking-tight">
                Reject delegate
              </h5>
              <Button
                className="p-2 rounded-full bg-white shadow-none hover:shadow-none hover:bg-black hover:bg-opacity-5"
                onClick={() => setDeleteModal(!deleteModal)}
              >
                <IoClose className="w-4 h-4 text-greyText" />
              </Button>
            </div>
            <div className="p-5 border-b border-authBorder">
              <p className="text-base font-ibm-regular text-black">
                Are you sure, you want to reject this delegate from attending
                the meeting ?
              </p>
              <p className="text-base font-ibm-regular text-greyText mt-2">
                Note: Once you submit this form, the registration amount will be
                refunded to the delegate.
              </p>
            </div>
            <div className="flex items-center justify-end px-5 py-3">
              <Button
                onClick={() => {
                  handleStatusChange(deleteId, "rejected");
                  setDeleteModal(!deleteModal);
                }}
                className="text-base shadow-none hover:shadow-none bg-[#EF4444] hover:bg-opacity-80 px-8 py-3 rounded-md font-ibm-semibold text-white transition-all duration-300 ease-in-out normal-case"
              >
                Refund amount
              </Button>
            </div>
          </DialogBody>
        </Dialog>

        {/* VIEW DETAILS MODAL */}
        <Dialog
          open={viewModal}
          handler={() => setViewModal(!viewModal)}
          size="sm"
          animate={{
            mount: { scale: 1, y: 0 },
            unmount: { scale: 0.9, y: -100 },
          }}
        >
          <DialogBody className="p-0 max-h-[90vh] flex flex-col overflow-hidden">
            {/* HEADER */}
            <div className="shrink-0 border-b border-gray-200 px-5 py-3 flex items-center justify-between">
              <h5 className="text-lg font-ibm-semibold text-black">
                View Registration Details{" "}
                {selectedRegistration?.registrationId &&
                  `- (Registration ID: ${selectedRegistration?.registrationId})`}
              </h5>
              <Button
                className="p-2 rounded-full bg-white shadow-none hover:shadow-none hover:bg-black hover:bg-opacity-5"
                onClick={() => setViewModal(!viewModal)}
              >
                <IoClose className="w-4 h-4 text-greyText" />
              </Button>
            </div>

            {/* BODY */}
            <div className="flex-1 overflow-y-auto p-5">
              {selectedRegistration && (
                <div className="p-0">
                  {/* NAME */}
                  <div className="mb-4">
                    <p className="text-md font-ibm-regular text-greyText">
                      <span className="text-black font-ibm-semibold">
                        Name:
                      </span>{" "}
                      {selectedRegistration.name}
                    </p>
                  </div>

                  {/* EMAIL */}
                  <div className="mb-4">
                    <p className="text-md font-ibm-regular text-greyText">
                      <span className="text-black font-ibm-semibold">
                        Email:
                      </span>{" "}
                      {selectedRegistration.email}
                    </p>
                  </div>

                  {/* LOHANA CONNECT ID */}
                  <div className="mb-4">
                    <p className="text-md font-ibm-regular text-greyText">
                      <span className="text-black font-ibm-semibold">
                        Lohana Connect ID:
                      </span>{" "}
                      {selectedRegistration.lohanaConnectId}
                    </p>
                  </div>

                  {/* PHONE */}
                  <div className="mb-4">
                    <p className="text-md font-ibm-regular text-greyText">
                      <span className="text-black font-ibm-semibold">
                        Phone number:
                      </span>{" "}
                      {selectedRegistration.phoneNumber}
                    </p>
                  </div>

                  {/* WHATSAPP PHONE NUMBER */}
                  <div className="mb-4">
                    <p className="text-md font-ibm-regular text-greyText">
                      <span className="text-black font-ibm-semibold">
                        Whatsapp Phone number:
                      </span>{" "}
                      {selectedRegistration.whatsAppPhoneNumber}
                    </p>
                  </div>

                  {selectedRegistration?.organization && (
                    <div className="mb-4">
                      <p className="text-md font-ibm-regular text-greyText">
                        <span className="text-black font-ibm-semibold">
                          Organization:
                        </span>{" "}
                        {selectedRegistration?.organization}
                      </p>
                    </div>
                  )}

                  {location === "Nashik" && (
                    <div className="mb-4">
                      <p className="text-md font-ibm-regular text-greyText">
                        <span className="text-black font-ibm-semibold">
                          Standing Committees / સ્થાયી સમિતિઓ:
                        </span>{" "}
                        {selectedRegistration?.standingCommittee || "Not selected"}
                      </p>
                    </div>
                  )}

                  {/* ZONE */}
                  {selectedRegistration?.designation && (
                    <div className="mb-4">
                      <p className="text-md font-ibm-regular text-greyText">
                        <span className="text-black font-ibm-semibold">
                          Designation:
                        </span>{" "}
                        {selectedRegistration?.designation}
                      </p>
                    </div>
                  )}

                  {/* ZONE */}
                  <div className="mb-4">
                    <p className="text-md font-ibm-regular text-greyText">
                      <span className="text-black font-ibm-semibold">
                        Zone:
                      </span>{" "}
                      {selectedRegistration.zone}
                    </p>
                  </div>

                  {/* REGION, CITY */}
                  <div className="flex items-center gap-10">
                    <div className="mb-4">
                      <p className="text-md font-ibm-regular text-greyText">
                        <span className="text-black font-ibm-semibold">
                          Region:
                        </span>{" "}
                        {selectedRegistration.region}
                      </p>
                    </div>
                    <div className="mb-4">
                      <p className="text-md font-ibm-regular text-greyText">
                        <span className="text-black font-ibm-semibold">
                          City:
                        </span>{" "}
                        {selectedRegistration.city}
                      </p>
                    </div>
                  </div>

                  {/* STATE */}
                  <div className="mb-4">
                    <p className="text-md font-ibm-regular text-greyText">
                      <span className="text-black font-ibm-semibold">
                        State:
                      </span>{" "}
                      {selectedRegistration.state}
                    </p>
                  </div>

                  {location === "Nashik" &&
                    renderParticipationEventsSection(
                      selectedRegistration?.participationEvents,
                    )}

                  <div className="mb-4 border-t border-authBorder pt-4">
                    <p className="text-md font-ibm-semibold text-black mb-3">
                      Payment Details
                    </p>
                    {viewDetailsLoading ? (
                      <p className="text-sm font-ibm-regular text-greyText">
                        Loading payment details...
                      </p>
                    ) : (
                      <>
                        <div className="mb-3">
                          <p className="text-md font-ibm-regular text-greyText">
                            <span className="text-black font-ibm-semibold">
                              Amount:
                            </span>{" "}
                            {selectedRegistration?.amount
                              ? `₹${selectedRegistration.amount}`
                              : "-"}
                          </p>
                        </div>
                        <div className="mb-3">
                          <p className="text-md font-ibm-regular text-greyText">
                            <span className="text-black font-ibm-semibold">
                              Payment Status:
                            </span>{" "}
                            <span
                              className={
                                getPaymentStatusLabel(
                                  selectedRegistration?.paymentStatus,
                                ).className
                              }
                            >
                              {
                                getPaymentStatusLabel(
                                  selectedRegistration?.paymentStatus,
                                ).label
                              }
                            </span>
                          </p>
                        </div>
                        <div className="mb-3">
                          <p className="text-md font-ibm-regular text-greyText">
                            <span className="text-black font-ibm-semibold">
                              Payment Mode:
                            </span>{" "}
                            {selectedRegistration?.paymentMode || "-"}
                          </p>
                        </div>
                        <div className="mb-3">
                          <p className="text-md font-ibm-regular text-greyText break-all">
                            <span className="text-black font-ibm-semibold">
                              Transaction ID:
                            </span>{" "}
                            {selectedRegistration?.paymentId || "-"}
                          </p>
                        </div>
                        <div className="mb-3">
                          <p className="text-md font-ibm-regular text-greyText break-all">
                            <span className="text-black font-ibm-semibold">
                              Merchant Payment ID:
                            </span>{" "}
                            {selectedRegistration?.merchantPaymentId || "-"}
                          </p>
                        </div>
                        {selectedRegistration?.shareablePaymentUrl && (
                          <div className="mb-3">
                            <p className="text-md font-ibm-regular text-greyText break-all">
                              <span className="text-black font-ibm-semibold">
                                WhatsApp Payment Link:
                              </span>{" "}
                              <span className="text-greyText">
                                {selectedRegistration.shareablePaymentUrl}
                              </span>
                            </p>
                            <p className="text-xs font-ibm-regular text-greyText mt-2">
                              Share this link on WhatsApp. It opens from
                              mumbaimeeting.lohanamahaparishad.org first, then
                              redirects to PhonePe.
                            </p>
                          </div>
                        )}
                        {canRegeneratePaymentLink && !viewDetailsLoading && (
                          <div className="mb-3 flex flex-wrap items-center gap-3">
                            <Button
                              onClick={handleRegeneratePaymentLink}
                              disabled={regenerateLinkLoading}
                              className="text-sm shadow-none hover:shadow-none bg-logoRed hover:bg-opacity-80 px-4 py-2 rounded-md font-ibm-semibold text-white transition-all duration-300 ease-in-out normal-case"
                            >
                              {regenerateLinkLoading
                                ? "Generating..."
                                : "Generate New Payment Link"}
                            </Button>
                            {selectedRegistration?.shareablePaymentUrl && (
                              <Button
                                onClick={() =>
                                  handleCopyPaymentLink(
                                    selectedRegistration.shareablePaymentUrl,
                                  )
                                }
                                className="text-sm shadow-none hover:shadow-none bg-white border border-authBorder hover:bg-black hover:bg-opacity-5 px-4 py-2 rounded-md font-ibm-semibold text-black transition-all duration-300 ease-in-out normal-case"
                              >
                                Copy WhatsApp Link
                              </Button>
                            )}
                          </div>
                        )}
                        {canRegeneratePaymentLink && !viewDetailsLoading && (
                          <p className="text-xs font-ibm-regular text-greyText mb-3">
                            Payment status refreshes automatically every 30
                            seconds while this window is open.
                          </p>
                        )}
                        {selectedRegistration?.meetingLocation && (
                          <div className="mb-3">
                            <p className="text-md font-ibm-regular text-greyText">
                              <span className="text-black font-ibm-semibold">
                                Meeting Location:
                              </span>{" "}
                              {selectedRegistration.meetingLocation}
                            </p>
                          </div>
                        )}
                        {selectedRegistration?.type && (
                          <div className="mb-3">
                            <p className="text-md font-ibm-regular text-greyText">
                              <span className="text-black font-ibm-semibold">
                                Registration Type:
                              </span>{" "}
                              {selectedRegistration.type}
                            </p>
                          </div>
                        )}
                        {selectedRegistration?.paymentDetails?.length > 0 && (
                          <div className="mb-3">
                            <p className="text-md font-ibm-regular text-greyText">
                              <span className="text-black font-ibm-semibold">
                                Payment Logs:
                              </span>{" "}
                              {selectedRegistration.paymentDetails.length}{" "}
                              record(s)
                            </p>
                          </div>
                        )}
                      </>
                    )}
                  </div>

                  {/* QR CODE */}
                  {selectedRegistration?.qrCode && (
                    <div className="mb-4">
                      <img
                        src={IMAGE_URL + selectedRegistration?.qrCode}
                        className=" w-44"
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          </DialogBody>
        </Dialog>

        {/* REMOVE DETAILS */}
        <Dialog
          open={removeDetailsModal}
          handler={() => setRemoveDetailsModal(!removeDetailsModal)}
          size="xs"
          animate={{
            mount: { scale: 1, y: 0 },
            unmount: { scale: 0.9, y: -100 },
          }}
        >
          <DialogBody className="p-0">
            <div className="border-b border-authBorder px-5 py-3 flex items-center justify-between">
              <h5 className="text-lg font-ibm-bold text-black tracking-tight">
                Remove Registration Details
              </h5>
              <Button
                className="p-2 rounded-full bg-white shadow-none hover:shadow-none hover:bg-black hover:bg-opacity-5"
                onClick={() => setRemoveDetailsModal(!removeDetailsModal)}
              >
                <IoClose className="w-4 h-4 text-greyText" />
              </Button>
            </div>
            <div className="p-5 border-b border-authBorder">
              <p className="text-base font-ibm-regular text-black">
                Are you sure you want to remove this details?
              </p>
            </div>
            <div className="flex items-center justify-end px-5 py-3">
              <Button
                onClick={() => {
                  handleDelete();
                }}
                className="text-base shadow-none hover:shadow-none bg-[#EF4444] hover:bg-opacity-80 px-8 py-3 rounded-md font-ibm-semibold text-white transition-all duration-300 ease-in-out normal-case"
              >
                Delete
              </Button>
            </div>
          </DialogBody>
        </Dialog>

        {/* UPDATE ALL STATUS MODAL */}
        <Dialog
          open={updateAllModal}
          handler={() => setUpdateAllModal(!updateAllModal)}
          size="xs"
          animate={{
            mount: { scale: 1, y: 0 },
            unmount: { scale: 0.9, y: -100 },
          }}
        >
          <DialogBody className="p-0">
            <div className="border-b border-authBorder px-5 py-3 flex items-center justify-between">
              <h5 className="text-lg font-ibm-bold text-black tracking-tight">
                Update Registration Details
              </h5>
              <Button
                className="p-2 rounded-full bg-white shadow-none hover:shadow-none hover:bg-black hover:bg-opacity-5"
                onClick={() => setUpdateAllModal(!updateAllModal)}
              >
                <IoClose className="w-4 h-4 text-greyText" />
              </Button>
            </div>
            <div className="p-5 border-b border-authBorder">
              <p className="text-base font-ibm-regular text-black mb-3">
                Are you sure you want to update these details?
              </p>

              <Select
                options={[
                  { value: "approved", label: " Approve Registration" },
                  {
                    value: "rejected",
                    label: "Reject Delegate",
                  },
                ]}
                className="react-select font-proxima-regular"
                classNamePrefix="filter"
                placeholder="Status"
                name="status"
                value={updateAllStatus}
                onChange={(e) => setUpdateAllStatus(e)}
              />
            </div>
            <div className="flex items-center justify-end px-5 py-3">
              <Button
                onClick={() => {
                  handleCombineStatusChange();
                }}
                className="text-base shadow-none hover:shadow-none bg-[#EF4444] hover:bg-opacity-80 px-8 py-3 rounded-md font-ibm-semibold text-white transition-all duration-300 ease-in-out normal-case"
              >
                Update
              </Button>
            </div>
          </DialogBody>
        </Dialog>

        {/* EDIT DETAILS MODAL */}
        <Dialog
          open={editModal}
          handler={() => setEditModal(!editModal)}
          size="s"
          animate={{
            mount: { scale: 1, y: 0 },
            unmount: { scale: 0.9, y: -100 },
          }}
        >
          <DialogBody className="p-0 max-h-[90vh] flex flex-col overflow-hidden">
            {/* HEADER */}
            <div className="shrink-0 border-b border-gray-200 px-5 py-3 flex items-center justify-between">
              <h5 className="text-lg font-ibm-semibold text-black">
                Edit Registration Details{" "}
                {editDetails?.registrationId &&
                  `- (Registration ID: ${editDetails?.registrationId})`}
              </h5>
              <Button
                className="p-2 rounded-full bg-white shadow-none hover:shadow-none hover:bg-black hover:bg-opacity-5"
                onClick={() => setEditModal(!editModal)}
              >
                <IoClose className="w-4 h-4 text-greyText" />
              </Button>
            </div>

            {/* BODY */}
            <div className="flex-1 overflow-y-auto p-5">
              {editDetails && (
                <div className="p-0 grid grid-cols-2 gap-4">
                  {/* NAME */}
                  <div className="grid-cols-1">
                    <p className="text-md font-ibm-regular text-greyText">
                      <span className="text-black font-ibm-semibold">Name</span>{" "}
                      {/* {editDetails.name} */}
                    </p>
                    <Input
                      type="text"
                      placeholder="Name..."
                      name="name"
                      id="name"
                      value={editDetails.name}
                      onChange={(e) => {
                        setEditDetails({
                          ...editDetails,
                          name: e.target.value,
                        });
                      }}
                    />
                  </div>

                  {/* EMAIL */}
                  <div className="grid-cols-1">
                    <p className="text-md font-ibm-regular text-greyText">
                      <span className="text-black font-ibm-semibold">
                        Email
                      </span>{" "}
                      {/* {editDetails.email} */}
                    </p>
                    <Input
                      type="text"
                      placeholder="Email"
                      name="email"
                      id="email"
                      value={editDetails?.email}
                      onChange={(e) => {
                        setEditDetails({
                          ...editDetails,
                          email: e.target.value,
                        });
                      }}
                    />
                  </div>

                  {/* PHONE NUMBER */}
                  <div className="grid-cols-1">
                    <p className="text-md font-ibm-regular text-greyText">
                      <span className="text-black font-ibm-semibold">
                        Phone Number
                      </span>{" "}
                      {/* {editDetails.name} */}
                    </p>
                    <Input
                      type="text"
                      placeholder="Phone Number..."
                      name="phoneNumber"
                      id="phoneNumber"
                      disabled={true}
                      value={editDetails.phoneNumber}
                    />
                  </div>

                  {/* NAME */}
                  <div className="grid-cols-1">
                    <p className="text-md font-ibm-regular text-greyText">
                      <span className="text-black font-ibm-semibold">
                        WhatsApp Phone Number
                      </span>{" "}
                      {/* {editDetails.name} */}
                    </p>
                    <Input
                      type="text"
                      placeholder="WhatsApp Phone Number..."
                      name="whatsAppPhoneNumber"
                      id="whatsAppPhoneNumber"
                      disabled={true}
                      value={editDetails?.whatsAppPhoneNumber}
                    />
                  </div>

                  {editDetails?.organization && (
                    <div className="grid-cols-1">
                      <p className="text-md font-ibm-regular text-greyText">
                        <span className="text-black font-ibm-semibold">
                          Organization
                        </span>{" "}
                        {/* {editDetails?.organization} */}
                      </p>
                      <Input
                        type="text"
                        placeholder="Organization"
                        name="organization"
                        id="organization"
                        value={editDetails?.organization}
                        onChange={(e) => {
                          setEditDetails({
                            ...editDetails,
                            organization: e.target.value,
                          });
                        }}
                      />
                    </div>
                  )}

                  {location === "Nashik" && (
                    <div className="grid-cols-1 col-span-2">
                      <p className="text-md font-ibm-regular text-greyText">
                        <span className="text-black font-ibm-semibold">
                          Standing Committees / સ્થાયી સમિતિઓ
                        </span>
                      </p>
                      <Select
                        name="standingCommittee"
                        id="standingCommittee"
                        options={standingCommittees}
                        className="react-select font-proxima-regular"
                        classNamePrefix="filter"
                        placeholder="Select standing committee"
                        value={
                          standingCommittees.find(
                            (option) =>
                              option.value === editDetails?.standingCommittee,
                          ) || null
                        }
                        onChange={(e) => {
                          setEditDetails({
                            ...editDetails,
                            standingCommittee: e?.value || "",
                          });
                        }}
                      />
                    </div>
                  )}

                  {/* ZONE */}
                  {editDetails?.designation && (
                    <div className="grid-cols-1">
                      <p className="text-md font-ibm-regular text-greyText">
                        <span className="text-black font-ibm-semibold">
                          Designation
                        </span>{" "}
                        {/* {editDetails?.designation} */}
                      </p>
                      <Input
                        type="text"
                        placeholder="Designation"
                        name="designation"
                        id="designation"
                        value={editDetails?.designation}
                        onChange={(e) => {
                          setEditDetails({
                            ...editDetails,
                            designation: e.target.value,
                          });
                        }}
                      />
                    </div>
                  )}

                  {/* ZONE */}
                  <div className="grid-cols-1">
                    <p className="text-md font-ibm-regular text-greyText">
                      <span className="text-black font-ibm-semibold">Zone</span>{" "}
                      {/* {editDetails.zone} */}
                    </p>
                    {/* <Input
                      type="text"
                      placeholder="Zone"
                      name="zone"
                      id="zone"
                      value={editDetails?.zone}
                      onChange={(e) => {
                        setEditDetails({
                          ...editDetails,
                          zone: e.target.value,
                        });
                      }}
                    /> */}
                    <Select
                      name="zone"
                      id="zone"
                      options={[...nationalList, ...internationalList]}
                      className="react-select font-proxima-regular"
                      classNamePrefix="filter"
                      placeholder="Select the zone"
                      value={[...nationalList, ...internationalList].find(
                        (option) => option?.label === editDetails?.zone,
                      )}
                      onChange={(e) => {
                        setEditDetails({
                          ...editDetails,
                          zone: e?.label,
                        });
                      }}
                    />
                  </div>

                  {/* REGION, CITY */}
                  <div className="col-span-1">
                    <div className="">
                      <p className="text-md font-ibm-regular text-greyText">
                        <span className="text-black font-ibm-semibold">
                          Region
                        </span>{" "}
                        {/* {editDetails.region} */}
                      </p>
                      <Input
                        type="text"
                        placeholder="Region"
                        name="region"
                        id="region"
                        value={editDetails?.region}
                        onChange={(e) => {
                          setEditDetails({
                            ...editDetails,
                            region: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-span-1">
                    <div className="">
                      <p className="text-md font-ibm-regular text-greyText">
                        <span className="text-black font-ibm-semibold">
                          City
                        </span>{" "}
                        {/* {editDetails.city} */}
                      </p>
                      <Input
                        type="text"
                        placeholder="City"
                        name="city"
                        id="city"
                        value={editDetails?.city}
                        onChange={(e) => {
                          setEditDetails({
                            ...editDetails,
                            city: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>

                  {/* STATE */}
                  <div className="grid-cols-1">
                    <p className="text-md font-ibm-regular text-greyText">
                      <span className="text-black font-ibm-semibold">
                        State
                      </span>{" "}
                      {/* {editDetails.state} */}
                    </p>
                    {/* <Input
                      type="text"
                      placeholder="State"
                      name="state"
                      id="state"
                      value={editDetails?.state}
                      onChange={(e) => {
                        setEditDetails({
                          ...editDetails,
                          state: e.target.value,
                        });
                      }}
                    /> */}
                    <Select
                      name="state"
                      id="state"
                      options={stateOptions}
                      className="react-select font-proxima-regular"
                      classNamePrefix="filter"
                      placeholder="Select the state"
                      value={stateOptions.find(
                        (option) => option.value === editDetails?.state,
                      )}
                      onChange={(e) => {
                        setEditDetails({
                          ...editDetails,
                          state: e?.value,
                        });
                      }}
                    />
                  </div>

                  {location === "Nashik" && (
                    <div className="col-span-2">
                      <p className="text-md font-ibm-regular text-greyText mb-2">
                        <span className="text-black font-ibm-semibold">
                          Participation Events
                        </span>
                      </p>
                      <div className="max-h-48 overflow-y-auto space-y-2 border border-authBorder rounded-md p-3">
                        {participationEvents.map((event) => {
                          const eventMap = normalizeParticipationEventsMap(
                            editDetails?.participationEvents,
                          );

                          return (
                            <label
                              key={event.id}
                              className="flex items-start gap-2 cursor-pointer"
                            >
                              <input
                                type="checkbox"
                                className="mt-1"
                                checked={eventMap[event.id]}
                                onChange={() =>
                                  toggleParticipationEvent(event.id)
                                }
                              />
                              <span className="text-sm font-ibm-regular text-greyText">
                                {event.label}
                              </span>
                            </label>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {/* QR CODE */}
                  {editDetails?.qrCode && (
                    <div className="mb-4">
                      <img
                        src={IMAGE_URL + editDetails?.qrCode}
                        className=" w-44"
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="shrink-0 px-3 py-3 border-t border-authBorder">
              <Button
                onClick={handleEditDetails}
                type="button"
                disabled={editDetailsLoading}
                className="w-full xl:w-[20vh] lg:w-[20vh] text-base shadow-none hover:shadow-none  hover:bg-opacity-80 px-5 py-3 rounded-md font-ibm-semibold text-white transition-all duration-300 ease-in-out normal-case "
              >
                {editDetailsLoading ? "Please wait..." : "Update Details"}
              </Button>
            </div>
          </DialogBody>
        </Dialog>
      </div>
    </section>
  );
};

export default RegistrationUs;
